import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchAlerts } from '../api/alerts';
import type { AlertKind } from '../config/alerts';
import { useAppStore } from '../store/appStore';
import type { Alert } from '../types/alerts';

export function useAlertsQuery() {
  return useQuery({
    queryKey: ['alerts'],
    queryFn: ({ signal }) => fetchAlerts(signal),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}

/** Alerts whose kind is toggled on; "other" kinds are always shown. */
export function useVisibleAlerts(alerts: Alert[] | undefined): Alert[] {
  const toggles = useAppStore((s) => s.alertToggles);
  return useMemo(() => {
    if (!alerts) return [];
    return alerts.filter((a) => {
      const kind: AlertKind = a.kind;
      return kind === 'other' ? true : toggles[kind];
    });
  }, [alerts, toggles]);
}
